import React, { useState, useEffect } from 'react';


import './detail.css';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

import InputGroup from 'react-bootstrap/InputGroup';

import { IoCheckmarkSharp } from "react-icons/io5";


import { FaWhatsapp } from "react-icons/fa";

import Header from '../../components/header/header';
import Footer from '../../components/footer/footer';
import Gallery from '../../components/propertyGallery/gallery';
import FormatPrice from '../../components/property/formatPrice';
import RelatedProperties from '../../components/property/relatedProperty';
import FindValueByAttributeCode from '../../components/property/findValueByAttributeCode';

import Form from 'react-bootstrap/Form';

import Card from 'react-bootstrap/Card';



import { IoLocation } from "react-icons/io5";
import { IoEye } from "react-icons/io5";



import { MdOutlineEmail } from "react-icons/md";

import { BsEnvelope } from "react-icons/bs";

import { IoWarningOutline } from "react-icons/io5";

import { LuShare2 } from "react-icons/lu";

import { FaFacebookF } from "react-icons/fa";
import { FaTwitter } from "react-icons/fa";

import { useNavigate, useParams, useLocation } from "react-router-dom";

import {connect} from 'react-redux';
import * as actions from '../../store/property/actions';




const PropertyDetail =({ getProperty, detail }) => {  
    const locationRoute =  useLocation();
    let match = useParams("/detail/:slug"); 
    const navigate = useNavigate();
    const attributeNotDisplayInBluk= ['property_description', 'other_amenities', 'price', 'area', 'flat_area', 'area_unit', 'is_rent', 'is_sale'];
    const [description, setDecription] = useState('');
    const [ amenities, setAmenities ] = useState('');
    const [ price, setPrice ] = useState('');
    const [ propertyType,  setPropertyType ] = useState()
    const [ propertyArea,  setPropertyArea ] = useState('')
    const [ mapLocation,  setMapLocation ] = useState('')

    const [show, setShow] = useState(true);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    useEffect(() => {
		loadData();
	},[]);
    // console.log(detail)
    useEffect(() => {
        if(detail && detail != ''){
            
            const propertyPrice = detail.attributes.find(
                (attribute) => attribute.code === 'price'
            );
            setPrice(propertyPrice);

            const isOnRent = detail.attributes.find(
                (attribute) => attribute.code === 'is_rent'
            );
            
            if(isOnRent && isOnRent != ''){
                setPropertyType('Rent');
            } else {
                setPropertyType('Sale');
            }
            

            if(detail.location != ''){
                const locationOfProperty = "https://maps.google.com/maps?width=600height=400&hl=en&q="+detail.location+' '+detail.city+"&t=&z=14&ie=UTF8&iwloc=B&output=embed";
                // const locationOfProperty = "https://maps.google.com/maps?width=600&amp;height=400&amp;hl=en&amp;q="+detail.location+' '+detail.city+"&amp;t=&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed";
                setMapLocation(locationOfProperty);
                
            }
        }

	},[detail]);

    // console.log(detail)

    const loadData = async() => {
        getProperty({property: match.slug})
    }


    const WhatsAppLink = ({ phone, message }) => {
        const whatsappUrl = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;
        return (
            <a href={whatsappUrl} target="_blank" className="btn btn-info mb-3" rel="noopener noreferrer">
                <FaWhatsapp /> Message Via Whatsapp
            </a>
        );
    };

    const WhatsAppShare = ({ url, text }) => {
        // console.log('window.location.href', window.location.href)
        const encodedText = encodeURIComponent(text);
        const encodedUrl = encodeURIComponent(url);
        const whatsappLink = `https://wa.me/?text=${encodedText}%20${encodedUrl}`;
      
        return (
          <a
            href={whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            className="me-2 btn btn-success"
          >
            <FaWhatsapp />
          </a>
        );
    };

    
    const FacebookShare = ({ url, text }) => {
        const encodedUrl = encodeURIComponent(url);
        const facebookLink = `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`;
      
        return (
          <a
            href={facebookLink}
            target="_blank"
            rel="noopener noreferrer"
            className="me-2 btn btn-info"
          > <FaFacebookF />
          </a>
        );
    };

    const TwitterShare = ({ url, text }) => {
        const encodedText = encodeURIComponent(text);
        const encodedUrl = encodeURIComponent(url);
        const whatsappLink = `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedText}`;
      
        return (
          <a
            href={TwitterShare}
            target="_blank"
            rel="noopener noreferrer"
            className="me-2 btn btn-primary"
          >
            <FaTwitter />
          </a>
        );
        
    }

    const SendSMS = ({ phone, message }) => {
        return <a className="btn btn-info" href={`sms:${phone}?body=${encodeURIComponent(message)}`}><MdOutlineEmail /> Message Via email</a>;
    };
    
    return (
        <div>
            <Header/>            

            <section className='pt-5 pb-5'>
                {
                detail ?
                <Container>
                    <Row className='justify-content-center'>
                        <Col lg={8} xl={9}>
                            <h1>{detail.title} </h1>
                            <p className='text-muted'><IoLocation/> {detail.location}, {detail.city} &nbsp;  &nbsp;  &nbsp;  &nbsp; <IoEye /> 69,656 Viewed</p>
                            <div className='mt-4 mb-4'>
                                {/* { 
                                    detail.images && detail.images.length>0 ?
                                        detail.images.map((pImage, index)=> {
                                            return pImage.is_primary == 1 ? 
                                                <img className="w-100" src={`${config.uploadUrl}${pImage.image_url}`} />
                                            :
                                                null
                                        })
                                    :
                                    <img className="w-100" src='https://static01.nyt.com/images/2023/09/21/multimedia/21sp-cli-home-01-cqhz/21sp-cli-home-01-cqhz-videoSixteenByNineJumbo1600.jpg'/>
                                } */}
                                <Gallery Images={detail.images} />
                            </div>
                            <div className='mt-4'>
                                <h4>Descriptions</h4>
                                <p><FindValueByAttributeCode  attributeCode={'property_description'} attributes={detail.attributes} /></p>
                            </div>                            
                            <div className='mt-4'>
                                <h4>Features</h4>
                                {
                                    detail.attributes && detail.attributes.length > 0 ?
                                    <ul className='d-flex navlist p-0 m-0'>
                                        {
                                            detail.attributes.map((attribute, attributeIndnex) => { 
                                                return attributeNotDisplayInBluk.includes(attribute.code) ? null : <li key={`propertyFeature${attributeIndnex}`}><span className="text-primary"><IoCheckmarkSharp/></span> {attribute.label}: {attribute.value == 1 ? 'Yes' : attribute.value}</li>
                                            })
                                        }
                                    </ul> 
                                    : ''
                                } 

                            </div>
                            {
                            amenities && amenities != ''
                            ?                            
                            <div className='mt-4'>
                                <h4>Other Amenities</h4>
                                <ul className='d-flex navlist p-0 m-0'>
                                    <li><span className="text-primary"><IoCheckmarkSharp/></span> Area: 323 squre feet</li>
                                    <li><span className="text-primary"><IoCheckmarkSharp/></span> Building Type: Residential</li>
                                    <li><span className="text-primary"><IoCheckmarkSharp/></span> Area: 323 squre feet</li>
                                    <li><span className="text-primary"><IoCheckmarkSharp/></span> Building Type: Residential</li>
                                    <li><span className="text-primary"><IoCheckmarkSharp/></span> Area: 323 squre feet</li>
                                    <li><span className="text-primary"><IoCheckmarkSharp/></span> Building Type: Residential</li>
                                </ul>
                            </div> 
                            : ''
                            } 
                            {   
                                detail.seo_links && detail.seo_links.length > 0 ?                      
                                    <div className='mt-4'>
                                        <h4>You can also visit</h4>
                                        {
                                            detail.seo_links.map((seolink, seoLinkIndex)=> {
                                                return <p key={`seolink${seoLinkIndex}`}><a href={seolink.link_url}>{seolink.label}</a></p>
                                            })
                                        }
                                    </div>  
                                : '' 
                            }                         
                        </Col>
                        <Col lg={4} xl={3}>
                            <div className='card p-3'>
                                <div className='d-flex justify-content-between align-items-center'>
                                    
                                    <h3>{ price && price.value ? <FormatPrice price={price.value} /> : ''}</h3>
                                    {/* <Button variant='info'><IoMdHeartEmpty/></Button> */}
                                </div>
                                <hr/>
                                { WhatsAppLink('+919829016873', `I'm intrested in your  ${detail.title} ${detail.location} ${detail.city} property`)}
                                { SendSMS('+919829016873', `I'm intrested in your  ${detail.title} ${detail.location} ${detail.city} property`)}
                                <hr/>
                                <div className='posterBox d-flex align-items-center mb-2'>
                                        <figure className='mb-0 me-2'></figure>    
                                    <div>
                                        <div className='text-muted'>Add by:</div>
                                        <h6 className='mb-0'>{detail.posted_by.full_name}</h6>
                                    </div>
                                </div>
                                <p className='mb-0'><BsEnvelope /> {detail.posted_by.email}</p>       
                                <hr/>
                                <h5>Ads Location</h5>                        
                                <div>
                                    <div className="mapouter">
                                        <div className="gmap_canvas">
                                            { mapLocation ? <iframe width='100%' className="gmap_iframe" frameBorder="0" scrolling="no" marginHeight="0" marginwidth="0" src={mapLocation}></iframe> : '' }
                                        </div>
                                    </div>
                                </div>                                
                            </div>
                            <div className='card p-3 mt-4'>
                                <h3 className='mb-0'>Overview</h3>
                                <div>
                                    <div className='d-flex mt-2 justify-content-between'>{detail.property_type} <span className='text-muted'></span></div>
                                    <div className='d-flex mt-2 justify-content-between'>Area 
                                        <span className='text-muted'>
                                            <FindValueByAttributeCode attributeCode={'area'} attributes={detail.attributes} />
                                            <FindValueByAttributeCode attributeCode={'flat_area'} attributes={detail.attributes} />
                                            &nbsp;<FindValueByAttributeCode attributeCode={'area_unit'} attributes={detail.attributes} />
                                        </span></div>
                                    <div className='d-flex mt-2 justify-content-between'>Property is on <span className='text-muted'>{propertyType}</span></div>
                                </div>
                                <hr/>
                                <h5 className='mb-0'><a href='#'><IoWarningOutline/> Report Abuse</a></h5>
                                <hr/>
                                <h5><LuShare2 /> Share Ads</h5>
                                <div>
                                    { WhatsAppShare(window.location.href, detail.title) }
                                    {TwitterShare(locationRoute.pathname, detail.title)}
                                    {FacebookShare(locationRoute.pathname, detail.title)}
                                </div>
                            </div>
                        </Col>
                        { detail && propertyType ? <RelatedProperties propertyTypeId={detail.property_type_id} propertyType={propertyType} entityId={detail.entity_id} /> : '' }
                    </Row>
                </Container>
                : ''
                }
            </section>

            
            <Footer/>

{/* whatsapp modal pop up start */}
            <Modal onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Customer Information</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <Form>
                
                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                    <Form.Label>Name</Form.Label>
                    <Form.Control
                        type="text"
                        placeholder=""
                        autoFocus
                    />
                </Form.Group>
                <Row>
                <Form.Group className="mb-3" as={Col} md="8"  controlId="exampleForm.ControlInput1">
                    <Form.Label>Phone No.</Form.Label>
                    <InputGroup className="mb-3">
                        <InputGroup.Text>+91</InputGroup.Text>
                        <Form.Control
                        placeholder=""
                        aria-label=""
                        aria-describedby="basic-addon2"
                        />
                        <Button variant="outline-secondary" id="button-addon2">
                        Verify
                        </Button>
                    </InputGroup>
                </Form.Group>
                <Form.Group className="mb-3" as={Col} md="4"  controlId="exampleForm.ControlInput1">
                    <Form.Label>OTP</Form.Label>
                    <Form.Control
                        type="text"
                        placeholder=""
                        autoFocus
                    />
                </Form.Group>
                </Row>
                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                    <Form.Label>Email address</Form.Label>
                    <Form.Control
                        type="email"
                        placeholder="name@example.com"
                        autoFocus
                    />
                    </Form.Group>
                <Form.Group
                className="mb-3"
                controlId="exampleForm.ControlTextarea1"
                >
                <Form.Label>Example textarea</Form.Label>
                <Form.Control as="textarea" rows={3} />
                </Form.Group>
            </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" onClick={handleClose}>
            Send Message
          </Button>
        </Modal.Footer>
            </Modal>
{/* whatsapp modal pop up end*/}

{/* report abuse pop up start*/}
<Modal show={show} onHide={handleClose} >
        <Modal.Header closeButton>
          <Modal.Title>Report Abuse</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <Form>
                
                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                    <Form.Label>Name</Form.Label>
                    <Form.Control
                        type="text"
                        placeholder=""
                        autoFocus
                    />
                </Form.Group>
                <Row>
                <Form.Group className="mb-3" as={Col} md="8"  controlId="exampleForm.ControlInput1">
                    <Form.Label>Phone No.</Form.Label>
                    <InputGroup className="mb-3">
                        <InputGroup.Text>+91</InputGroup.Text>
                        <Form.Control
                        placeholder=""
                        aria-label=""
                        aria-describedby="basic-addon2"
                        />
                        <Button variant="outline-secondary" id="button-addon2">
                        Verify
                        </Button>
                    </InputGroup>
                </Form.Group>
                <Form.Group className="mb-3" as={Col} md="4"  controlId="exampleForm.ControlInput1">
                    <Form.Label>OTP</Form.Label>
                    <Form.Control
                        type="text"
                        placeholder=""
                        autoFocus
                    />
                </Form.Group>
                </Row>
                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                    <Form.Label>Email address</Form.Label>
                    <Form.Control
                        type="email"
                        placeholder="name@example.com"
                        autoFocus
                    />
                    </Form.Group>
                <Form.Group
                className="mb-3"
                controlId="exampleForm.ControlTextarea1"
                >
                <Form.Label>Example textarea</Form.Label>
                <Form.Control as="textarea" rows={3} />
                </Form.Group>
            </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" onClick={handleClose}>
            Send Message
          </Button>
        </Modal.Footer>
            </Modal>
{/* report abuse pop up end*/}

</div>
    )
}
function mapStateToProps(state) {
    
    return {
        detail: state.property.detail
    };
}
  
function mapDispatchToProps(dispatch) {
    return {
          getProperty: (post) => dispatch(actions.getProperty(post))
    };
}
  
export default connect(mapStateToProps, mapDispatchToProps)(PropertyDetail);